import {
  Filters,
  locationOfCourse,
  PaginationBase,
  SearchAnnouncePaginatedQueryDto,
  SortCriteria,
} from '@les-sherpas/sherpas-toolbox';

const pagination: PaginationBase = {
  currentPage: 1,
  sortByDescending: true,
  sortCriteria: SortCriteria.Score,
  limit: null,
};

/** le prix maximal de la search renvoyé au back */
export const MAX_PRICE_SEARCH_VALUE = 1_000_000;

const filters: Filters = {
  alreadyFetchedIds: [],
  subject: '',
  address: null,
  educationalStages: [],
  minPrice: 15_00,
  maxPrice: 60_00, // histoire d'avoir tous les cours possibles de base
  courseLocations: [locationOfCourse.online],
  availabilities: [],
  gender: null,
  onlyCertifiedSherpas: false,
  onlyAvailableSherpas: false,
  onlyAnswerFastSherpas: false,

  isFromSeo: false,
};

export const defaultFilters: SearchAnnouncePaginatedQueryDto = {
  pagination,
  filters,
};
